(() => {
  const init = root => {
    const sections = root.matches?.('[data-category-videos]') ? [root] : root.querySelectorAll?.('[data-category-videos]') || [];
    sections.forEach(section => {
      if (section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';
      const tabs = [...section.querySelectorAll('[data-category-tab]')];
      const panels = [...section.querySelectorAll('[data-category-panel]')];
      if (!tabs.length || !panels.length) return;

      const activate = index => {
        tabs.forEach((tab, i) => {
          const active = i === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel, i) => {
          const active = i === index;
          panel.setAttribute('aria-hidden', String(!active));
          panel.classList.toggle('is-active', active);
          const video = panel.querySelector('video');
          if (!video) return;
          if (active && !matchMedia('(prefers-reduced-motion: reduce)').matches) video.play().catch(() => {});
          else { video.pause(); video.muted = true; }
          panel.querySelector('[data-category-sound]')?.classList.remove('is-sounding');
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', event => {
          if (!['ArrowDown','ArrowUp','ArrowRight','ArrowLeft'].includes(event.key)) return;
          event.preventDefault();
          const forward = event.key === 'ArrowDown' || event.key === 'ArrowRight';
          const next = (index + (forward ? 1 : -1) + tabs.length) % tabs.length;
          activate(next);
          tabs[next].focus();
        });
      });

      section.addEventListener('click', event => {
        const button = event.target.closest('[data-category-sound]');
        if (!button) return;
        const video = button.closest('[data-category-panel]')?.querySelector('video');
        if (!video) return;
        video.muted = !video.muted;
        button.classList.toggle('is-sounding', !video.muted);
        button.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Mute video');
        video.play().catch(() => {});
      });

      activate(0);
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
